/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgEdit = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M5.85 15.365 5.143 18.9l3.535-.707 8.485-8.485-2.828-2.829zm13.788-8.132c1.061-1.06 0-2.121 0-2.121l-.707-.708s-1.06-1.06-2.121 0l-1.06 1.061 2.828 2.829z" /></svg>;
export default SvgEdit;